import React, { useState, useEffect } from 'react';
import { Button, Dropdown } from 'react-bootstrap';
import { FaUserCircle, FaBars, FaKey, FaSignOutAlt } from 'react-icons/fa';
import { useAuth } from '../../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import NotificationBell from '../../../components/notifications/NotificationBell';

const Topbar = ({ onMenuClick }) => {
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [userDisplayData, setUserDisplayData] = useState({
    name: 'Admin',
    role: 'Super Admin',
    initials: 'A'
  });
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      const displayName = (user.first_name && user.last_name)
        ? `${user.first_name} ${user.last_name}`
        : user.email || 'Admin';
      
      const initials = (user.first_name && user.last_name)
        ? `${user.first_name.charAt(0)}${user.last_name.charAt(0)}`.toUpperCase()
        : user.email?.charAt(0).toUpperCase() || 'A';
      
      let roleDisplay = 'Super Admin';
      const roleValue = parseInt(user.role);
      switch (roleValue) {
        case 0: roleDisplay = 'Super Admin'; break;
        case 1: roleDisplay = 'User'; break;
        case 2: roleDisplay = 'Organization Admin'; break;
        default: roleDisplay = 'Super Admin';
      }

      setUserDisplayData({
        name: displayName,
        role: roleDisplay,
        initials: initials
      });
    }
  }, [user]);

  const handleLogout = async () => {
    setShowUserMenu(false);
    await logout();
    navigate('/', { replace: true });
  };

  const handleNavigate = (path) => {
    setShowUserMenu(false);
    navigate(path);
  };

  return (
    <div className="sticky top-0 z-50 border-b brand-app-header-border shadow-lg">
      <div className="brand-app-header py-2 px-3 md:py-3">
        <div className="flex items-center justify-between gap-3 max-w-7xl mx-auto">

          {/* LEFT: Hamburger + Title */}
          <div className="flex items-center gap-3 flex-1 min-w-0">
            <Button
              bsPrefix="custom-hamburger"
              className="!bg-transparent !border-none !text-white d-md-none p-1.5 rounded-lg hover:bg-white/10 [&_.btn]:hidden"
              onClick={onMenuClick}
            >
              <FaBars className="w-5 h-5" />
            </Button>
            <div className="flex-1 min-w-0">
              <div className="text-lg sm:text-xl md:text-2xl font-bold text-white truncate">
                Enable LXP
              </div>
              <div className="hidden md:block text-sm text-gray-200">
                Super Admin Panel
              </div>
            </div>
          </div>

          {/* RIGHT: Bell + User */}
          <div className="flex items-center gap-2 sm:gap-3">

            <div className="flex items-center justify-center">
              <NotificationBell />
            </div>

            <Dropdown align="end" show={showUserMenu} onToggle={setShowUserMenu}>
              <Dropdown.Toggle
                as="button"
                className="flex items-center gap-2 px-2 py-1 rounded-lg bg-white/20 hover:bg-white/30 text-white transition border border-purple-500 sm:border sm:hover:bg-white/30 sm:bg-white/20 sm:flex sm:items-center sm:gap-2 sm:px-2 sm:py-1  sm:rounded-lg sm:text-white sm:transition after:!content-none"
              >
                <span className="rounded-full bg-white/30 text-white flex items-center justify-center font-semibold text-sm w-7 h-7 sm:w-8 sm:h-8 sm:text-base ">
                  {userDisplayData.initials}
                </span>
                <div className="hidden sm:block text-left leading-tight">
                  <div className="text-sm font-semibold text-white">{userDisplayData.name}</div>
                  <div className="text-xs text-gray-200">{userDisplayData.role}</div>
                </div>
              </Dropdown.Toggle>
   <Dropdown.Menu 
  className="mt-2 shadow-2xl rounded-2xl border-0 bg-white/95 backdrop-blur-xl p-3 min-w-[260px] overflow-hidden"
  align="end"
>

  <div
    role="menuitem"
    className="flex items-center gap-3 p-2 rounded-xl hover:bg-purple-50/80 transition-all duration-300 cursor-pointer group whitespace-nowrap"
    onClick={() => handleNavigate('/admin/profile')}
  >
    <div className="p-2 rounded-lg bg-gradient-to-br from-purple-600 to-pink-600 text-white shadow-md group-hover:shadow-purple-500/50 group-hover:scale-110 transition-all">
      <FaUserCircle className="w-5 h-5" />
    </div>
    <span className="font-medium text-gray-800 group-hover:text-purple-700">Profile</span>
  </div>

  <div
    role="menuitem"
    className="flex items-center gap-3 p-2 rounded-xl hover:bg-purple-50/80 transition-all duration-300 cursor-pointer group whitespace-nowrap"
    onClick={() => handleNavigate('/admin/change-password')}
  >
    <div className="p-2 rounded-lg bg-gradient-to-br from-indigo-600 to-purple-600 text-white shadow-md group-hover:shadow-purple-500/50 group-hover:scale-110 transition-all">
      <FaKey className="w-5 h-5" />
    </div>
    <span className="font-medium text-gray-800 group-hover:text-purple-700">Change Password</span>
  </div>

  <hr className="my-3 border-0 h-px bg-gradient-to-r from-transparent via-purple-300 to-transparent" />

  <div
    role="menuitem"
    onClick={handleLogout}
    className="flex items-center gap-3 p-2 rounded-xl hover:bg-red-50/80 transition-all duration-300 cursor-pointer group whitespace-nowrap"
  >
    <div className="p-2 rounded-lg bg-gradient-to-br from-red-500 to-rose-600 text-white shadow-md group-hover:shadow-red-500/50 group-hover:scale-110 transition-all">
      <FaSignOutAlt className="w-5 h-5" />
    </div>
    <span className="font-bold text-red-600 group-hover:text-red-700">Sign Out</span>
  </div>
</Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Topbar;